// 전역 변수
export default Object.freeze({
    DefaultProductCd: '9999999',//현장계약번호 default
})
